// constants
import { StoreStorageSyncKeys } from 'components/mrp/mrp.consts';

// types
import { ContextPanelStore } from './ContextPanel.types';

// utils
import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from 'zustand/middleware';
import { ContextPanelSize } from './ContextPanel.types';

export const useContextPanelStore = createWithEqualityFn<ContextPanelStore>()(
  persist(
    (set) => ({
      hasHydrated: false,
      panelSize: ContextPanelSize.MEDIUM,
      prevPanelSize:
        ContextPanelSize.MEDIUM /* In case we temporarily change the panel size, and later wish to revert it */,
      control: {
        setPanelSize: (panelSize: ContextPanelSize) =>
          set((state) => {
            return {
              ...state,
              prevPanelSize: state.panelSize,
              panelSize
            };
          })
      }
    }),
    {
      name: StoreStorageSyncKeys.CONTEXT_PANEL_STORE,
      partialize: (state) => ({
        panelSize: state.panelSize
      }),
      onRehydrateStorage: (state) => {
        state.hasHydrated = true;
      },
      version: 1
    }
  )
);
